import { create } from 'zustand';

/**
 * Petit canal impératif pour **rejouer** une visite à la demande (ADR-0031, incrément 2). Un bouton
 * de section pose une demande (`requestTour`) ; l'`OnboardingHost` la consomme et lance la visite,
 * en contournant la logique « déjà vue » (c'est un rejeu explicite). Séparé de l'état persistant :
 * le rejeu n'écrit rien tant que la visite n'est pas terminée/passée.
 */
interface TourStore {
  requested: string | null;
  requestTour: (scope: string) => void;
  consume: () => void;
  /**
   * `true` quand une visite ancrée sur le rail (ex. `overview`) est en cours. La coquille force
   * alors l'ouverture du tiroir de navigation sur mobile, pour que les coachmarks pointent des
   * entrées **réellement visibles** (sinon le rail est replié hors écran, ADR-0031). Sans effet sur
   * desktop, où le rail est déjà persistant.
   */
  railOpen: boolean;
  setRailOpen: (open: boolean) => void;
}

export const useTourStore = create<TourStore>((set) => ({
  requested: null,
  requestTour: (scope) => set({ requested: scope }),
  consume: () => set({ requested: null }),
  railOpen: false,
  setRailOpen: (open) => set({ railOpen: open }),
}));
